import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { useGetTransportAssignmentIdsMutation } from '../../api/transportOrderApi';
import { getBulkSelection, transportAssignmentsSlice } from '../../reducers/transportAssignmentsSlice';
import { useAppDispatch, useAppSelector } from '../../../../configuration/setup/hooks';
import { FIXED_TRANSPORT_ASSIGNMENT_CACHE_KEY } from './TransportAssignmentBulkSelectionDropdown';

export const TRANSPORT_ASSIGNMENT_CONTENT_LOADER_TEST_ID = 'transport-assignment-selection-cell-loader';

export const TransportAssignmentSelectionCell = ({ assignmentId }: { assignmentId: string }) => {
    const dispatch = useAppDispatch();
    const isSelected = useAppSelector((state) => getBulkSelection(state).includes(assignmentId));
    const [, { isLoading }] = useGetTransportAssignmentIdsMutation({
        fixedCacheKey: FIXED_TRANSPORT_ASSIGNMENT_CACHE_KEY,
    });

    const onSelect = () => {
        if (isSelected) {
            dispatch(transportAssignmentsSlice.actions.removeFromBulkSelection([assignmentId]));
        } else {
            dispatch(transportAssignmentsSlice.actions.addToBulkSelection([assignmentId]));
        }
    };

    const ariaLabel = isSelected ? 'Remove assignment from selection' : 'Add assignment to selection';

    return (
        <td className="table-checkbox">
            {isLoading ? (
                <ContentLoader data-testid={TRANSPORT_ASSIGNMENT_CONTENT_LOADER_TEST_ID} />
            ) : (
                <Checkbox onChange={onSelect} checked={isSelected} aria-label={ariaLabel} />
            )}
        </td>
    );
};
